// stores/reservationStore.ts
import { defineStore } from 'pinia';
import { RESERVATION_STATUS } from '@core/enums';
import { string } from 'yup';

interface ReservationItem {
  timeId: number;
  timeStatus: string;
  resveDate: string;
  resveCourse: string;
  confirmVisitCnt: number;
  resveTime: string;
  partDiv: string;
  timeDiv: string;
  holeDiv: string;
  shotgunFlag: number;
  webOpenFlag: boolean;
  agncyOpenFlag: boolean;
  coprtnOpenFlag: boolean;
  selfOpenFlag: boolean;
  joinOpenFlag: boolean;
  aditTeamFlag: boolean;
  galleyTeamFlag: boolean;
  per4Flag: boolean;
  visitCnt: number;
  resveRtrvlMethod: RESERVATION_STATUS;
  optFlag: number;
  delFlag: boolean;
  insertId: number;
  updateId: number;
  updateDt: string;
  tgResveConfirms: any[];
  tgResvePromtn: any;
  timeZoneDiv: string;
  grpResveFlag: boolean;
  cancelableFlag: boolean;
  changeableFlag: boolean;
  transChangeableFlag: boolean;
  promtnPrice?: number;
  eventPrice?: number;
  price: number;
  cartPrice: number;
  caddieFee: number;
}
interface SelectedDateInfo {
  selectDay: string;
  weekDay: string;
}

export const useReservationStore = defineStore('reservation', {
  state: () => ({
    selectedDate: {} as SelectedDateInfo,
    reservationData: [] as ReservationItem[],
    reservationId: string,
    reservationStatus: '' as string,
  }),
  actions: {
    setReservationData(date: any, data: any, resveId: any, status: string) {
      this.selectedDate = date;
      this.reservationData = data;
      this.reservationId = resveId;
      this.reservationStatus = status;
    },
  },
});
